import { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqData: FAQItem[] = [
    {
      question: 'Can I add and manage multiple residents?',
      answer:
        'Yes, you can easily add residents, edit their details, archive old records, and manage all resident information securely.',
    },
    {
      question: 'How does payment processing work?',
      answer:
        'Our payment processing system integrates with secure payment gateways to handle transactions. You can accept various payment methods, track payment history, and generate receipts automatically.',
    },
    {
      question: 'What kind of reports can I generate?',
      answer:
        'You can generate comprehensive reports including financial summaries, resident activity logs, payment histories, occupancy rates, and custom reports based on your specific needs.',
    },
    {
      question: 'Do I need a Stripe account to receive payments?',
      answer:
        "Yes, you'll need to connect a Stripe account to process payments. The setup is straightforward and ensures secure, PCI-compliant payment processing for your residents.",
    },
    {
      question: 'Can I upgrade or downgrade my plan later?',
      answer:
        "Absolutely! You can upgrade or downgrade your plan at any time. Changes will be reflected in your next billing cycle, and we'll prorate any differences accordingly.",
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className=" bg-gray-50 py-8 md:py-16 lg:py-32 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-5xl font-bold text-center mb-4 md:mb-12 text-gray-900">
          FAQ
        </h1>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-2 md:py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-200"
              >
                <span className="text-lg md:text-xl font-semibold text-primary pr-4">
                  {faq.question}
                </span>
                <div className="flex-shrink-0">
                  {openIndex === index ? (
                    <Minus className="w-6 h-6 text-gray-600" />
                  ) : (
                    <Plus className="w-6 h-6 text-gray-600" />
                  )}
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index
                    ? 'max-h-96 opacity-100'
                    : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5 pt-2">
                  <p className="text-secondary text-base md:text-xl leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <button className="text-indigo-600 hover:text-indigo-700 font-medium text-lg transition-colors duration-200">
            Load more
          </button>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
